import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export const useOnChangeLocation = (
  handleChangeLocation: () => void,
  includeSearch = false,
) => {
  const location = useLocation();
  const previousLocation = useRef(location);

  useEffect(() => {
    if (
      [
        previousLocation.current.pathname !== location.pathname,
        ...(includeSearch
          ? [previousLocation.current.search !== location.search]
          : []),
      ].some(Boolean)
    ) {
      handleChangeLocation();
    }

    previousLocation.current = location;
  }, [location, includeSearch, handleChangeLocation]);
};
